import type { BrandOverrides } from '../types';

// Values alison's Incubeta override never defined (alison2 has tokens alison lacks) are
// tints of Incubeta purple/orange chosen for contrast; confirm with Incubeta before launch.
export const incubetaBrand: BrandOverrides = {
  fontFamily: '"Montserrat", "Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  primary: { main: '#9901FF', dark: '#5802F7', light: '#F3E8FF', bg: '#F3E8FF' },
  secondary: { main: '#FF9637', dark: '#E37CA1', light: '#FFF1E6' },
  info: { main: '#911E90', bg: '#F9E8F9' },
  text: { primary: '#000000', secondary: '#434343' },
  background: { page: '#F5F5F5', muted: '#EDEDED' },
  border: { default: '#D8D8D8', strong: '#C4C4C4', light: '#E6CCFF', primary: '#9901FF' },
  gradients: {
    primary: 'linear-gradient(90deg, #9901FF 0%, #5802F7 100%)',
    primaryHover: 'linear-gradient(90deg, #5802F7 0%, #4302C2 100%)',
    progress: 'linear-gradient(90deg, #B366FF 0%, #FF9637 100%)',
    subtle: 'linear-gradient(90deg, #F3E8FF 0%, #FFF1E6 100%)',
  },
};
